import React from 'react';
import { Card } from './ui/card';
import { Shield, Scale, Award, TrendingUp, Gavel, Globe, CheckCircle, Lock, Trophy, Star } from 'lucide-react';
import { benefitsData } from '../data/mock';

const iconMap = {
  0: Shield,
  1: Scale,
  2: Award,
  3: TrendingUp,
  4: Gavel,
  5: Globe,
  6: CheckCircle,
  7: Lock,
  8: Trophy,
  9: Star
};

const Benefits = () => {
  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4">
              {benefitsData.title}
            </h2>
            <div className="w-24 h-1 bg-[#2d8b8b] mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {benefitsData.subtitle}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {benefitsData.benefits.map((benefit, index) => {
              const Icon = iconMap[index];
              return (
                <Card
                  key={index}
                  className="p-8 hover:shadow-xl transition-all duration-300 border-l-4 border-[#2d8b8b] hover:-translate-y-1"
                >
                  <div className="flex gap-6">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] rounded-lg flex items-center justify-center">
                        <Icon className="w-8 h-8 text-white" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-[#1e3a5f] mb-3">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
